const FlagPeru = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="mask0_695_488"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <path
                    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                    fill="#C4C4C4"
                />
            </mask>
            <g mask="url(#mask0_695_488)">
                <path
                    d="M22.3112 -0.71106H-6.3999V16.0356H22.3112V-0.71106Z"
                    fill="#BA242A"
                />
                <path
                    d="M10.9156 -0.71106H4.99561V16.0356H10.9156V-0.71106Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export default FlagPeru
